import Vue from 'vue'
import req from 'libs/http'
import checkForm from 'libs/checkForm'
import dialog from 'libs/dialog'
import user from '@/services/user'
import eventBus from 'libs/eventBus';
import { getConfig } from 'config'
import util from 'libs/util'

const func = {
  $dialog: dialog,
  $confirm: dialog.confirm,
  $toast: dialog.toast,
  $loading: dialog.loading,
  $alert: dialog.alert,
  $user: user,
  $checkForm: checkForm,
  $axios: req.axios,
  $get: req.get,
  $post: req.post,
  $eventBus: eventBus,
  $getCourseImg(info = {}, kind) {
    const staticUrl = getConfig('STATICURL');
    info.thumbnailUrlDetail = info.thumbnailUrl;
    if (!info.thumbnailUrlDetail) {
      info.thumbnailUrlDetail = `${staticUrl}/course-detail-def.png`;
    }
    if (!info.thumbnailUrl) {
      info.thumbnailUrl = `${staticUrl}/course-def.png`;
      info.shareThumbnailUrl = ''
    } else {
      info.shareThumbnailUrl = info.thumbnailUrl;
    }
    if (kind == 2) {
      info.thumbnailUrl = `${staticUrl}/v2/def-freeimg.png`;
    }
    return info;
  },
  $getCourseInfo(info = {}, kind) {
    info = this.$getCourseImg(info, kind);
    if (!info.book) {
      info.book = {};
    }
    if (!info.courseKind) {
      info.courseKind = {};
    }
    info.kindName = info.courseKind.id > 0 ? info.courseKind.name : '';
    info.courseFullName = [info.book.name, info.kindName, info.name].join(' ')
    info.halfName = [info.kindName, info.name].join(' ')
    return info;
  },
  $getBookImg(info = {}) {
    const staticUrl = getConfig('STATICURL');
    if (!info.detailCoverUrl) {
      info.detailCoverUrl = `${staticUrl}/v2/book_detail_def.png`;
    }
    return info;
  },
  $getBookListImg(list = []) {
    const staticUrl = getConfig('STATICURL');
    if (list) {
      list.forEach((item) => {
        if (!item.coverUrl) {
          item.coverUrl = `${staticUrl}/v2/book_def.png`;
        }
      });
    }
    return list;
  }
}
Object.keys(func).forEach((key) => {
  Vue.prototype[key] = func[key];
});
